(function () {
    if(typeof zooomyWish == 'undefined'){
        window.zooomyWish={};
    }

    let shop = zooomyWish.shop ?? Shopify.shop;

    // list view page 
    function ZooomyDataFun($zjqL, shop, customerid, customeremail) {

        let customername = zooomyWish.customerName ?? '';
        customeremail = zooomyWish.customerEmail ?? '';
        let zooomListUrl = "https://zooomyapps.com/wishlist/api/frontend/";
        let rootIs = lanTo = Shopify.routes.root;
        if (lanTo == "/") {
            lanTo = Shopify.locale;
        }
        
        let prIdsForAll = [];
        $zjqL.ajax({
            url: zooomListUrl + 'wishlist',
            method: 'post',
            data: {
                shop: shop,
                customerid: customerid,
                lang: lanTo
            },
            dataType: "json",
            async: "true",
            success: function(jsonData) {
                var usercss = jsonData.custom_css;
                var user_added_css = jsonData.user_added_css;
                var ids = jsonData.id;

                var product_id = jsonData.product_id;
                var variant_id = jsonData.variant_id;
                var product_price = jsonData.product_price;
                var product_handle = jsonData.product_handle;
                var product_name = jsonData.product_name;
                var product_img = jsonData.product_img;
                var wishlist_page_product_text = jsonData.wishlist_page_product_text;
                var wishlist_page_product_text_bg = jsonData.wishlist_page_product_text_bg;
                var wishlist_page_product_text_f_color = jsonData.wishlist_page_product_text_f_color;
                var wishlist_page_add_cart_text = jsonData.wishlist_page_add_cart_text;
                var wishlist_page_add_cart_text_f_color = jsonData.wishlist_page_add_cart_text_f_color;
                var wishlist_page_add_cart_text_bg = jsonData.wishlist_page_add_cart_text_bg;
                var remove_from_wishlist = jsonData.remove_from_wishlist;
                var remove_from_wishlist_f_color = jsonData.remove_from_wishlist_f_color;
                var remove_from_wishlist_bg = jsonData.remove_from_wishlist_bg;
                var layout = jsonData.layout;
                var shop_currency = getCurrencySymbol(Shopify.currency.active);
                var shop_name = jsonData.shop_name;
                var sold_out_text = jsonData.sold_out_text;
                var directdelete = jsonData.directdelete;
                var cus_email = jsonData.cus_email;
                var zemail_e_btn = jsonData.zemail_e_btn;
                var zemail_textarea = jsonData.zemail_textarea ?? '';

                var zemail_s_btn = jsonData.zemail_s_btn;
                var frnd_name = jsonData.frnd_name;
                var frnd_email = jsonData.frnd_email;
                var frnd_name_bg = jsonData.frnd_name_bg;
                var frnd_name_f_color = jsonData.frnd_name_f_color;
                var variant_name = jsonData.variant_name;
                var empty_text = jsonData.empty_text || "Your wishlist is empty.";
                var pricing_plan = jsonData.plan;
                var show_vendor = jsonData.show_vendor;

                var sharedata = "qyghbced" + customerid + "azhu607h";
                var savdatawp = jsonData.savdatawp;
                var wish_icon = jsonData.savdatawp;
                
                wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&Oslash;", "Ø").replace("&Aring;", "Å").replace("&AElig;", "Æ").replace("&oslash;", "ø").replace("&aring;", "å").replace("&aElig;", "æ");
                wishlist_page_product_text = wishlist_page_product_text.replace("&Oslash;", "Ø").replace("&Aring;", "Å").replace("&AElig;", "Æ").replace("&oslash;", "ø").replace("&aring;", "å").replace("&aElig;", "æ");
                remove_from_wishlist = remove_from_wishlist.replace("&Oslash;", "Ø").replace("&Aring;", "Å").replace("&AElig;", "Æ").replace("&oslash;", "ø").replace("&aring;", "å").replace("&aElig;", "æ");
                
                var data = [];

                // Helper function to render empty state message dynamically
                function checkEmptyWishlist() {
                    console.log('check empty wishlist');
                    if ($zjqL('#ZoomyWishlistPage .ZoomyWishlistPageGrid').length === 0) {
                        if ($zjqL('#ZoomyWishlistPage .zwishemptymsg').length === 0) {
                            $zjqL('#ZoomyWishlistPage').append(
                                `<div class="zwishemptymsg wishlist-wrapper">
                                    <div class="wishlist-box">
                                        <div class="icon-circle">
                                            <div class="heart" aria-hidden="true">♡</div>
                                        </div>
                                        <p class="zmsg">${empty_text}</p>
                                    </div>
                                </div>`
                            );
                        }
                    }
                }

                if (customerid == "") {
                    if (jsonData.w_login == "yes") {
                         $zjqL('#ZoomyWishlistPage').append(`<div class="wishlist-wrapper">
                            <div class="wishlist-box">
                            <div class="icon-circle">
                                <div class="heart" aria-hidden="true">♡</div>
                            </div>
                            ${Object.hasOwn(jsonData, "login_heading")?'<h1>'+jsonData.login_heading+'</h1>':''}

                            <a class="zmsg" href='${window.location.origin}/account/login'>${jsonData.login_save}</a>
                            <div class="other-text"></div>
                                ${Object.hasOwn(jsonData, "login_heading") ? 
                                    `<a class="login-btn" href='${window.location.origin}/account/login'>
                                        ${jsonData.login_button_text}
                                    </a>` 
                                : ''}
                            </div>
                        </div>`);

                        var pidsall = [];
                        var producthandle = [];
                        var ptitle = [];
                        var pprice = [];
                        var pimg = [];
                        var vname = [];
                        var vid = [];

                        if (localStorage.getItem("myzooomy__wishlist") != undefined) {
                            var nnitem = localStorage.getItem("myzooomy__wishlist");
                            data = JSON.parse(nnitem);

                            $zjqL.each(data, function(key, value) {
                                pidsall.push(value.product_id);
                                producthandle.push(value.product_handle);
                                pprice.push(value.proprice);
                                ptitle.push(value.protitle);
                                pimg.push(value.proimage);
                                vname.push(value.vname);
                                vid.push(value.vid ?? value.variant_id);
                            });
                        }
                        var ids = pidsall;
                        var product_id = pidsall;
                        var product_handle = producthandle;
                        var product_price = pprice;
                        var product_name = ptitle;
                        var product_img = pimg;
                        var variant_name = vname;
                        var variant_id = vid;
                    } else {
                         $zjqL('#ZoomyWishlistPage').append(`<div class="wishlist-wrapper">
                            <div class="wishlist-box">
                                    <div class="icon-circle">
                                        <div class="heart" aria-hidden="true">♡</div>
                                    </div>

                                    ${Object.hasOwn(jsonData, "login_heading")?'<h1>'+jsonData.login_heading+'</h1>':''}
                                    <a class="zmsg" href='${window.location.origin}/account/login'>${jsonData.login_text}</a>
                                   
                                    <div class="other-text"></div>
                                    ${Object.hasOwn(jsonData, "login_heading") ? 
                                        `<a class="login-btn" href='${window.location.origin}/account/login'>
                                        ${jsonData.login_button_text}
                                    </a>` 
                                    : ''}
                            </div>
                        </div>`);
                    }
                }

                $zjqL("body").append(`<style>#ZoomyWishlistPage .wishlist-wrapper { width: 100%; padding: 21px 49px; } #ZoomyWishlistPage .wishlist-box { max-width: 800px; max-height: 455px; margin: 0 auto; border: 1px solid #e5e2df; display: flex; flex-direction: column; align-items: center; text-align: center; padding-top: 20px; padding-bottom: 20px; } #ZoomyWishlistPage .icon-circle { width: 108px; height: 108px; border-radius: 50%; background: #f0f2f1; display: flex; align-items: center; justify-content: center; margin-bottom: 36px; } #ZoomyWishlistPage .heart { color: #000000; font-family: Arial, sans-serif; font-size: 57px; font-weight: 300; line-height: 1; transform: translateY(-2px); } #ZoomyWishlistPage .wishlist-box h1 { color: #858585; font-family: Georgia, "Times New Roman", serif; font-size: 25px; font-weight: 400; line-height: 1.2; margin-bottom: 22px; } #ZoomyWishlistPage .wishlist-box p,#ZoomyWishlistPage .wishlist-box a {text-decoration: none; color: #858585; font-size: 18px; font-weight: 400; line-height: 1.3; margin-bottom: 40px; } #ZoomyWishlistPage .login-btn { width: auto; height: auto; border: none; padding: 15px; border-radius: 7px; background: #000000; color: #ffffff; font-size: 18px; font-weight: 700; cursor: pointer; } @media (max-width: 850px) { #ZoomyWishlistPage .wishlist-wrapper { padding: 20px; } #ZoomyWishlistPage .wishlist-box { width: 100%; } } @media (max-width: 600px) { #ZoomyWishlistPage .wishlist-box { height: auto; min-height: 455px; padding: 50px 20px; } #ZoomyWishlistPage .wishlist-box h1 { font-size: 27px; } #ZoomyWishlistPage .wishlist-box p { font-size: 18px; } }</style>`);
                $zjqL('<style>#ZoomyWishlistPage .z_w_unavailable img { opacity: .5; } #ZoomyWishlistPage .zunavailable { cursor: not-allowed; opacity: .6; }</style>').appendTo('body');            
                if(Object.hasOwn(jsonData, "login_heading")){
                    let styleBox=`
                        <style>
                                #ZoomyWishlistPage .wishlist-wrapper .wishlist-box{
                                    background-color: ${jsonData.wishlist_box_bgcolor};
                                    border-color: ${jsonData.wishlist_box_bcolor};
                                }
                                #ZoomyWishlistPage .wishlist-wrapper .login-btn{
                                    background-color:${jsonData.login_button_bgcolor};
                                    color: ${jsonData.login_button_tcolor};
                                    font-size: ${jsonData.login_button_font_size};
                                }
                                #ZoomyWishlistPage .wishlist-wrapper h1{
                                    color: ${jsonData.box_heading_font_color};
                                    font-size: ${jsonData.box_heading_font_size};
                                }
                                #ZoomyWishlistPage .wishlist-wrapper p > #ZoomyWishlistPage .wishlist-wrapper a{
                                    color: ${jsonData.box_text_font_color};
                                    font-size: ${jsonData.box_text_font_size};
                                }
                                #ZoomyWishlistPage .wishlist-wrapper .icon-circle{
                                    background-color:${jsonData.logo_bgcolor};
                                }
                                #ZoomyWishlistPage .wishlist-wrapper .heart{
                                    color:${jsonData.logo_color};
                                }
                        </style>`;
                        $zjqL("body").append(styleBox);
                }
                $zjqL('<link rel="stylesheet" type="text/css" href="https://zooomyapps.com/wishlist/WishlistStyle.css">').appendTo("body");
                $zjqL('<style>' + usercss + '</style>').appendTo('body');
                if (jsonData.hide_cart_btn == "yes") {
                    $zjqL('<style>span#wishlist_page_product_text { width: 100%;} .zqty{display:none;} </style>').appendTo('body');
                }
                
                $zjqL('<style>span#opencart a { float: right; position: absolute; top: -64px; right: 50px; }span#opencart { float: right; width: 100%; position: relative; }</style>').appendTo('body');
                $zjqL('<style>.ZoomyWishlistPagecol li.zbodyaction { width: 42%; }.ZoomyWishlistPagecol li.zbodytitle { width: 31%; }.ZoomyWishlistPagecol li.zbodypimg { width: 20%; }.ZoomyWishlistPagecol li.zbodysno { width: 7%; } .ZoomyWishlistPagecol li.zheadaction { width: 42%; }.ZoomyWishlistPagecol li.zheadtitle { width: 31%; }.ZoomyWishlistPagecol li.zheadpimg { width: 20%; }.ZoomyWishlistPagecol li.zheadsno { width: 5%; }.ZoomyWishlistPagecol a, .rte .ZoomyWishlistPagecol a{border:none; outline:none;}.ZoomyWishlistPagecol button{padding: 10px 20px; margin: 2px 3px;border:none;}#wishlist_page_product_text{background:' + wishlist_page_product_text_bg + '; color:' + wishlist_page_product_text_f_color + '; }#wishlist_page_product_text a{color:' + wishlist_page_product_text_f_color + '; }</style>').appendTo('body');
                $zjqL('<style>.zopencartlink{background:' + wishlist_page_add_cart_text_bg + '; color:' + wishlist_page_add_cart_text_f_color + ';border: none; padding: 1px 10px; }</style>').appendTo('body');
                $zjqL('<style>.zremovefromwish{background:' + remove_from_wishlist_bg + '; color:' + remove_from_wishlist_f_color + '; }</style>').appendTo('body');
                if (cus_email == "false" || customerid == "") {
                    $zjqL('<style>#zooomyemailfbtn{display:none;}</style>').appendTo('body');
                }
                $zjqL('<style>.ZoomyWishlistPagecol li{float:left; width:25%; box-sizing:border-box; padding:10px; }.ZoomyWishlistPagecol{float: left; width: 100%;margin-bottom:10px; border-bottom:1px solid #ededed;}</style>').appendTo('body');

                if (product_id == 0 || product_id == "0" || product_id == null || product_id == "null" || (Array.isArray(product_id) && product_id.length === 0)) {
                    if (jsonData.w_login == "no") {
                        if($zjqL("#ZoomyWishlistPage .wishlist-wrapper").length==0){
                            $zjqL("#ZoomyWishlistPage").append("<div class='zwishemptymsg wishlist-wrapper'><div class='wishlist-box'><div class='icon-circle'> <div class='heart' aria-hidden='true'>♡</div> </div><p class='zmsg'>" + empty_text + "</p></div></div>");
                        }else{
                           $zjqL("#ZoomyWishlistPage .wishlist-box .other-text").append("<p class='zmsg'>" + empty_text + "</p>"); 
                        }
                    } 
                    $zjqL('<style>.ZoomyWishlistPagecol{display:none;}</style>').appendTo('body');
                }

                $zjqL("#ZoomyWishlistPage").before("<span class='zooomyaddtowishlistmsg' style='float:left;width:100%;'></span>");
                if (pricing_plan != "nfree" || pricing_plan != "free") {
                    $zjqL("#ZoomyWishlistPage").before("<span class='zooomybtn' id='zooomyemailfbtn' style='cursor:pointer;border: none;float:left; width:100%;'><button type='button' id='emailzwishlist' aria-expanded='false' aria-controls='zemaildata' style='background:" + frnd_name_bg + "; color:" + frnd_name_f_color + "; border:none; padding:10px; width:100%; cursor:pointer;'>" + zemail_e_btn + "</button></span>");
                    
                    $zjqL("#ZoomyWishlistPage").before(`
                        <div id='zemaildata' style='display:none;' aria-hidden='true'>
                            <form>
                                <label for='zemailname' class='zooomy-sr-only'>Your Name</label>
                                <input type='text' id='zemailname' name='name' autocomplete='name' placeholder='${frnd_name}' aria-required='true' required/>
                                
                                <label for='zemailid' class='zooomy-sr-only'>Your Email</label>
                                <input type='email' id='zemailid' name='email' autocomplete='email' placeholder='${frnd_email}' aria-required='true' required/>
                                
                                <label for='zemailmsg' class='zooomy-sr-only'>Message</label>
                                <textarea id='zemailmsg' name='message'> ${zemail_textarea} </textarea>
                                
                                <button type='button' id='zsendemail' style='background:${frnd_name_bg}; color:${frnd_name_f_color}; border:none; cursor:pointer;'>${zemail_s_btn}</button>
                            </form>
                        </div>
                    `);

                    if (cus_email == true || cus_email == "true") {
                        let host = window.location.host; 
                        let root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
                        let zdomain = host + root.replace(/\/$/, "");

                        $zjqL(".zooomybtn").append('<div class="z_social_share_wishlist"><a aria-label="Copy wishlist link" class="zooomylink_fa"><i class="fa fa-link" aria-hidden="true"></i></a><a aria-label="Share wishlist on Facebook" class="zsocial_icon" href="https://www.facebook.com/sharer/sharer.php?u=https://' + zdomain + '/pages/share-wish-list?' + sharedata + '&t=Wishlist" onclick="javascript:window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false;" target="_blank" title="Share on Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a><a aria-label="Share wishlist on Pinterest" class="zpinicon" href="http://pinterest.com/pin/create/button/?url=https://' + zdomain + '/pages/share-wish-list?' + sharedata + '&media=" onClick="javascript:window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false;" target="_blank" title="Share on Pinterest"><i class="fa fa-pinterest" aria-hidden="true"></i></a><a aria-label="Share wishlist on WhatsApp" class="zwhatsappicon" href="https://wa.me/?text=https://' + zdomain + '/pages/share-wish-list?' + sharedata + '" data-action="share/whatsapp/share" onClick="javascript:window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false;" target="_blank" title="Share on WhatsApp"><i class="fa fa-whatsapp" aria-hidden="true"></i></a><a aria-label="Share wishlist via Email" href="mailto:?subject=' + frnd_name + '&body=' + (zemail_textarea!=""? zemail_textarea+' : ':'') + 'https://' + zdomain + '/pages/share-wish-list?' + sharedata + '" onClick="javascript:window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false;" target="_blank" title="Share on Mail" class="zsemailicon"><i class="fa fa-envelope" aria-hidden="true"></i></a></div>');
                    }
                    $zjqL('<style> .z_social_share_wishlist .fa{background:' + frnd_name_bg + '; color:' + frnd_name_f_color + ';border:none;}</style>').appendTo('body');
                    
                    $zjqL("#ZoomyWishlistPage").before("<textarea id='zooomycopytxtarea' aria-hidden='true' tabindex='-1' style='display:none;margin:10px 0;float: left; width: 100%; text-align: center; padding: 10px; height: 58px; min-height: 20px; border: 1px solid #eee; font-size: 18px; color: #888;'>https://" + shop_name + "/pages/share-wish-list?" + sharedata + "</textarea>");
                }

                $zjqL('<style> #zsendemail{background:' + frnd_name_bg + '; color:' + frnd_name_f_color + ';border:none;}</style>').appendTo('body');

                if (layout == "list") {
                    $zjqL("#ZoomyWishlistPage").addClass("zooomywishlistlistclass");
                    $zjqL('<style>' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass{width:100%;clear:both;margin:25px 0;box-sizing:border-box;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid{float:none;width:100%;margin:0;padding:22px 0;border:0;border-bottom:1px solid #e5e5e5;text-align:left;box-sizing:border-box;overflow:visible;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid ul{display:grid;grid-template-columns:120px minmax(180px,1fr) 110px minmax(200px,280px) minmax(140px,200px) 44px;align-items:center;column-gap:16px;width:100%;margin:0;padding:0;list-style:none;box-sizing:border-box;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid li{float:none;width:auto;padding:0;margin:0;box-sizing:border-box;list-style:none;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodypimg{width:120px;position:static;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodypimg img{width:95px;height:135px;object-fit:cover;display:block;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodytitle{min-width:0;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodytitle a{display:block;background:transparent;border:0;color:inherit;text-decoration:none;font-size:15px;line-height:1.4;height:auto;min-height:0;padding:0;word-break:normal;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zprice{display:block;width:110px;white-space:nowrap;font-size:16px;line-height:1.3;margin:0;padding:0;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodyinfo{display:flex;align-items:center;gap:10px;width:100%;margin:0;min-width:0;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zoptionbox{flex:1 1 auto;min-width:0;margin:0!important;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zoptionbox[style*="display: none"]{display:none!important;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zqty select{width:auto;height:42px;padding:4px 4px 4px 8px;border:1px solid #d8d8d8;background:#fff;box-sizing:border-box;font-size:14px;line-height:1.2;border-radius:4px;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zooomyshopvariant{width:100%;max-width:100%;height:42px;padding:4px 4px 4px 8px;border:1px solid #d8d8d8;background:#fff;box-sizing:border-box;font-size:14px;line-height:1.2;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;border-radius:4px;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction{display:block;width:100%;margin:0;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction .addcartbtn,#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction .zopencartlink{width:100%;min-width:0;margin:0;padding:10px 14px;box-sizing:border-box;text-align:center;white-space:nowrap;height:42px;line-height:1.2;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;border-radius:4px;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction a{text-decoration:none;color:inherit;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zremovebox{width:44px;min-width:44px;margin:0;padding:0;display:flex;align-items:center;justify-content:center;overflow:visible;}' +
                        '#ZoomyWishlistPage.zooomywishlistlistclass .zremovebox .removefromwishlist{display:flex;align-items:center;justify-content:center;position:static!important;right:auto!important;top:auto!important;transform:none!important;width:34px!important;height:34px!important;min-width:34px!important;line-height:34px!important;padding:0!important;margin:0!important;background:#000!important;color:#fff!important;border:0!important;text-align:center!important;cursor:pointer!important;}' +
                        '@media(max-width:1250px){#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid ul{grid-template-columns:115px minmax(180px,1fr) 105px minmax(200px,1fr) 44px;grid-template-areas:"zimg ztitle zprice zinfo zremove" "zimg zaction zaction zaction zremove";row-gap:14px;column-gap:16px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodypimg{grid-area:zimg;width:115px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodytitle{grid-area:ztitle;}#ZoomyWishlistPage.zooomywishlistlistclass .zprice{grid-area:zprice;width:105px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodyinfo{grid-area:zinfo;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction{grid-area:zaction;max-width:300px;}#ZoomyWishlistPage.zooomywishlistlistclass .zremovebox{grid-area:zremove;align-self:center;}}' +
                        '@media(max-width:750px){#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid{padding:18px 0;}#ZoomyWishlistPage.zooomywishlistlistclass .ZoomyWishlistPageGrid ul{grid-template-columns:90px 1fr 40px;grid-template-areas:"zimg ztitle zremove" "zimg zprice zremove" "zinfo zinfo zinfo" "zaction zaction zaction";column-gap:12px;row-gap:12px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodypimg{grid-area:zimg;width:90px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodypimg img{width:80px;height:105px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodytitle{grid-area:ztitle;}#ZoomyWishlistPage.zooomywishlistlistclass .zprice{grid-area:zprice;width:auto;font-size:14px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodyinfo{grid-area:zinfo;display:flex;width:100%;gap:10px;}#ZoomyWishlistPage.zooomywishlistlistclass .zqty{width:70px;}#ZoomyWishlistPage.zooomywishlistlistclass .zbodyaction{grid-area:zaction;width:100%;max-width:none;}#ZoomyWishlistPage.zooomywishlistlistclass .zremovebox{grid-area:zremove;width:40px;min-width:40px;align-self:start;justify-content:flex-end;}}' +
                        '</style>').appendTo("body");
                    setTimeout(function() {
                        $zjqL('#ZoomyWishlistPage.zooomywishlistlistclass .zooomyshopvariant').each(function() {
                            var $select = $zjqL(this);
                            var totalOptions = $select.find('option').length;
                            var selectedText = $select.find('option:selected').text();

                            if (totalOptions <= 1 && selectedText == 'Default Title') {
                                $select.closest('.zoptionbox').hide();
                            }
                        });
                    }, 800);
                } else {
                    $zjqL("#ZoomyWishlistPage").addClass("zooomywishlistgridclass");
                }

                $zjqL('<style>.zooomybtn.removefromwishlist.zremovefromwish{ cursor: pointer; border: none; padding: 0; margin: 0; box-sizing: border-box; line-height: 25px; height: 25px; width: 25px;}.ZoomyWishlistPageGrid span.zooomybtn { cursor:pointer;border: none; margin: 2px; padding: 4px 10px; margin-top: 20px; box-sizing: border-box; }.ZoomyWishlistPageGrid{float: left; width: 31.3%; box-sizing: border-box; position: relative; text-align: center; margin: 10px 1%; border: 1px solid #efefef; padding: 20px;}</style>').appendTo('body');
                $zjqL('<style>.ZoomyWishlistPageGrid .removefromwishlist {position: absolute; right: 0px; top:0;border: 0; background: ' + remove_from_wishlist_bg + ';color:' + remove_from_wishlist_f_color + '; padding: 0; margin: 0; line-height: 20px; height: 24px; width: 23px; text-align: center; }</style>').appendTo('body');

                $zjqL.each(ids, function(i, v) {
                    let cleanProductName = unescapeHtml(product_name[i]);

                    $zjqL("#ZoomyWishlistPage").append("<div class='ZoomyWishlistPageGrid productListIndex-"+i+"' id='ZoomyWishlistPageGrid-" + product_id[i] + "'><ul> <li class='zbodypimg'><a aria-label='" + cleanProductName + "' target='_blank' href='https://" + jsonData.shop_name + "/products/" + product_handle[i] + "?utm_source=zooomyWishlistApp'><img src='" + (product_img[i]|| 'https://cdn.shopify.com/s/files/1/0835/0236/6999/files/no-image.gif?v=1782395477&height=300') + "' width='100' alt='' aria-hidden='true'></a></li><li class='zbodytitle'><a aria-label='" + cleanProductName + "' href='https://" + jsonData.shop_name + "/products/" + product_handle[i] + "?utm_source=zooomyWishlistApp'>" + product_name[i] + "</a></li><li class='zbodyaction'><button id='addcartbtn-" + i + "' class='zbtn zooomybtn addcartbtn zopencartlink' value='" + product_handle[i] + "' data-pro-id='" + product_id[i] + "'>" + wishlist_page_add_cart_text + "</button></li></ul></div>");

                    if (layout == "list") {
                        $zjqL("#ZoomyWishlistPage .productListIndex-"+i+ " ul").append("<li class='zremovebox'><button id='rmvfrmwish" + product_id[i] + "' class='zooomybtn removefromwishlist zremovefromwish' value='" + product_id[i] + "' aria-label='Remove " + cleanProductName + " from wishlist'>x</button></li>");
                    } else {
                        $zjqL("#ZoomyWishlistPage .productListIndex-"+i+ " .zbodypimg").prepend("<button id='rmvfrmwish" + product_id[i] + "' class='zooomybtn removefromwishlist zremovefromwish' value='" + product_id[i] + "' aria-label='Remove " + cleanProductName + " from wishlist'>x</button>");
                    }
                  
                    var cartlink = 'https://' + jsonData.shop_name + '/cart';

                    $zjqL.ajax({
                        url: rootIs+'products/' + product_handle[i] + '.js',
                        dataType: 'json',
                        success: function(cartvalues) {
                            $zjqL(".productListIndex-"+i+" .zbodytitle").after(`
                                <li class='zbodyinfo'>
                                    <div class='zoptionbox'>
                                        <label for='zooomyshopvariant-${i}' class='zooomy-sr-only'>Select variant for ${cleanProductName}</label>
                                        <select class='zooomyshopvariant' id='zooomyshopvariant-${i}'></select>
                                    </div>
                                    <div class='zqty'>
                                        <label for='zqtyn-${i}' class='zooomy-sr-only'>Select quantity for ${cleanProductName}</label>
                                        <select id='zqtyn-${i}'>
                                            <option value='1'>1</option>
                                            <option value='2'>2</option>
                                            <option value='3'>3</option>
                                            <option value='4'>4</option>
                                            <option value='5'>5</option>
                                            <option value='6'>6</option>
                                            <option value='7'>7</option>
                                            <option value='8'>8</option>
                                            <option value='9'>9</option>
                                            <option value='10'>10</option>
                                        </select>
                                    </div>
                                </li>
                            `);

                            var variantprice = cartvalues.price;
                            var ava = cartvalues.variants.available;
                            if (show_vendor == "yes") {
                                $zjqL("#ZoomyWishlistPage .productListIndex-"+i+ " .zbodytitle").append('<div class="zpro_vendor">' + cartvalues.vendor + '</div>');
                            }

                            if (ava == undefined) {
                                var ava = cartvalues.available;
                            }
                            if (ava == false) {
                                $zjqL(".productListIndex-"+i+" .addcartbtn").text(sold_out_text);
                                $zjqL(".productListIndex-"+i+" .addcartbtn").addClass("z_w_soldout");
                            } else {
                                $zjqL(".productListIndex-"+i+" .addcartbtn").text(wishlist_page_add_cart_text);
                                $zjqL(".productListIndex-"+i+" .addcartbtn").removeClass("z_w_soldout");
                            }
                            variantprice = (variantprice) / 100;
                            variantprice = variantprice.toFixed(2);
                            if (shop_name == "jens-gullsmidur.myshopify.com") {
                                variantprice = variantprice * 100;
                            }
                            if (shop_name == "hello-sasha.myshopify.com") {
                                variantprice = variantprice + shop_currency;
                            } else {
                                variantprice = shop_currency + variantprice;
                            }
                            
                            $zjqL(".productListIndex-"+i+ " .zbodytitle a").text(cartvalues.title);
                            
                            $zjqL(".productListIndex-"+i+ " .zbodytitle").after("<li class='zprice-item'><span class='zprice' style='display:inline-block'>" + variantprice + "</span></li>");

                            let varintsAvailable = true;
                            let opitonselected = true;

                            $zjqL(cartvalues.variants).each(function(k, variants) {
                                var showselect = variants.title;
                                var vimg = variants.featured_image ? variants.featured_image.src : "";

                                let currentVarId = variant_id[i] ? variant_id[i].toString().trim() : "";
                                let isSelected = false;

                                if (currentVarId === "") {
                                    if (variants.available && opitonselected) {
                                        isSelected = true;
                                        opitonselected = false;
                                    }
                                } else if (parseInt(currentVarId, 10) === variants.id) {
                                    if (variants.available && opitonselected) {
                                        isSelected = true;
                                        opitonselected = false;
                                    }
                                }

                                $zjqL("#zooomyshopvariant-" + i).append($zjqL('<option>', {
                                    id: variants.id,
                                    value: variants.title,
                                    text: variants.title,
                                    'data-id': variants.id,
                                    'data-image': vimg,
                                    'data-price': variants.price,
                                    'data-available': variants.available,
                                    selected: isSelected
                                }));

                                if (showselect === "Default Title") {
                                    $zjqL("#ZoomyWishlistPage .productListIndex-" + i + " .zoptionbox").hide();
                                }

                                if (isSelected) {
                                    var dropdown = $zjqL("#zooomyshopvariant-" + i);
                                    var vavailable = variants.available;
                                    if (!vavailable) {
                                        $zjqL(".productListIndex-" + i + " .addcartbtn").text(sold_out_text).addClass("z_w_soldout");
                                    } else {
                                        $zjqL(".productListIndex-" + i + " .addcartbtn").text(wishlist_page_add_cart_text).removeClass("z_w_soldout");
                                    }

                                    if (currentVarId !== "") {
                                        variantprice = variants.price;
                                        variantprice = (variantprice) / 100;
                                        variantprice = variantprice.toFixed(2);
                                        if (shop_name === "jens-gullsmidur.myshopify.com") {
                                            variantprice = variantprice * 100;
                                        }
                                        if (shop_name === "hello-sasha.myshopify.com") {
                                            variantprice = variantprice + shop_currency;
                                        } else {
                                            variantprice = shop_currency + variantprice;
                                        }
                                        $zjqL(".productListIndex-" + i + " .zprice").text(variantprice);
                                    }
                                }

                                if (variants.available && varintsAvailable) {
                                    prIdsForAll.push({ "id": variants.id, "quantity": 1 });
                                    varintsAvailable = false;
                                }
                            });
                           
                            variant_name[i] = (typeof variant_name[i] == null || variant_name[i]==null) ? '' : variant_name[i].trim();

                            if (variant_name[i] != "") {
                                $zjqL("#zooomyshopvariant-" + i).val(variant_name[i]);
                            }
                            if (variant_name[i] == "") {
                                $zjqL("#zooomyshopvariant-" + i).val(cartvalues.variants[0].title);
                            }

                            let $selectBox = $zjqL("#zooomyshopvariant-" + i);
                            if (!$selectBox.val()) {
                                let $selectedOpt = $selectBox.find("option[selected]");
                                if ($selectedOpt.length > 0) {
                                    $selectBox.val($selectedOpt.val());
                                } else {
                                    $selectBox.val($selectBox.find("option:first").val());
                                }
                            }

                            let dropdown = $zjqL("#zooomyshopvariant-" + i);
                            let imgg = dropdown.find('option:selected').attr('data-image');
                            let vprice = dropdown.find('option:selected').attr('data-price');
                            let vavailable = dropdown.find('option:selected').attr('data-available');
                            if (vavailable == "false") {
                                $zjqL(".productListIndex-"+i+" .addcartbtn").text(sold_out_text);
                                $zjqL(".productListIndex-"+i+" .addcartbtn").addClass("z_w_soldout");
                            } else {
                                $zjqL(".productListIndex-"+i+" .addcartbtn").text(wishlist_page_add_cart_text);
                                $zjqL(".productListIndex-"+i+" .addcartbtn").removeClass("z_w_soldout");
                            }
                            if (imgg && imgg != "") {
                                $zjqL(".productListIndex-"+i+ " .zbodypimg img").attr('src', imgg);
                            }
                            vprice = (vprice) / 100;
                            vprice = vprice.toFixed(2);
                            if (shop_name == "hello-sasha.myshopify.com") {
                                vprice = vprice + shop_currency;
                            } else if(vprice!="NaN"){
                                vprice = shop_currency + vprice;
                            }
                            if (vprice != undefined && vprice != "$NaN" && vprice !='NaN') {
                                $zjqL(".productListIndex-"+i+ " .zprice").text(vprice);
                            }

                            $zjqL("#zooomyshopvariant-" + i + " option").each(function() {
                                if (this.value == 'Default Title') {
                                    $zjqL("#zooomyshopvariant-" + i).val("Default Title");
                                }
                            });

                            $zjqL(".productListIndex-" + i).off("change", "#zooomyshopvariant-" + i).on("change", "#zooomyshopvariant-" + i, function() {
                                var dropdown = $zjqL(this);
                                var selectedText = dropdown.find("option:selected").text();
                                var imgg = dropdown.find('option:selected').attr('data-image');
                                var vprice = dropdown.find('option:selected').attr('data-price');
                                var vavailable = dropdown.find('option:selected').attr('data-available');
                                var vid = dropdown.find('option:selected').attr('data-id');

                                if (vavailable === "false" || vavailable === false) {
                                    $zjqL(".productListIndex-" + i + " .addcartbtn")
                                        .text(sold_out_text)
                                        .addClass("z_w_soldout")
                                        .prop("disabled", true);

                                        return false;
                                } else {
                                    $zjqL(".productListIndex-" + i + " .addcartbtn")
                                        .text(wishlist_page_add_cart_text)
                                        .removeClass("z_w_soldout")
                                        .prop("disabled", false);
                                }
                                vprice = (vprice) / 100;
                                vprice = vprice.toFixed(2);
                                if (shop_name == "hello-sasha.myshopify.com") {
                                    vprice = vprice + shop_currency;
                                } else {
                                    vprice = shop_currency + vprice;
                                }

                                if (imgg && imgg != "") {
                                    $zjqL(".productListIndex-"+i+ " .zbodypimg img").attr('src', imgg);
                                }

                                $zjqL(".productListIndex-"+i+ " .zprice").text(vprice);

                                if (savdatawp == "yes") {
                                    $zjqL.ajax({
                                        url: zooomListUrl+"save-data-wishlist",
                                        type:'post',
                                        data: {
                                            shop: shop,
                                            productid: product_id[i],
                                            customerid: customerid,
                                            vid: vid,
                                            vname: selectedText,
                                            vprice: vprice
                                        },
                                        dataType: "json",
                                        async: "true",
                                        success: function(njData) {
                                            $zjqL(".productListIndex-"+i+ " .zoptionbox").append("<p class='zsavdatamsg' style='font-size: 12px; position: absolute; text-align: center; width: 100%; margin: 0; padding: 0; box-sizing: border-box; left: 4px;'>" + njData.datasaved + "</p>");
                                            setTimeout(function() {
                                                $zjqL('.zsavdatamsg').fadeOut('slow');
                                            }, 350);
                                        }
                                    });
                                }
                            });

                            $zjqL(".productListIndex-"+i+ " .addcartbtn").click(function() {
                                var dropdown = $zjqL("#zooomyshopvariant-" + i);
                                var selectedText = dropdown.find("option:selected").text();
                                if (selectedText == "") {
                                    alert("Please select value from dropdown");
                                }
                                var selectedValue = dropdown.find('option:selected').attr('data-id');

                                var ndropdown = $zjqL("#zqtyn-" + i);
                                var nzqtyval = ndropdown.val();
                                if (selectedValue == undefined) {
                                    selectedValue = product_id[i];
                                }

                                zooomywishlistpage(product_id[i], customeremail, customerid);

                                $zjqL.ajax({
                                    type: 'POST',
                                    url: rootIs+'cart/add.js',
                                    dataType: 'json',
                                    data: {
                                        quantity: nzqtyval,
                                        id: selectedValue,
                                    },
                                    success: function(a) {
                                        $zjqL.getJSON('/cart.js', function(cart) {
                                            if (directdelete == "true") {
                                                var wishlistid = product_id[i];
                                                data = data.filter(product => {
                                                    return product.product_id != wishlistid;
                                                });
                                                $zjqL(".zooomyaddtowishlistmsg").append('<span id="zooomyitemadded"><a aria-label="View items in cart" href="' + cartlink + '">' + jsonData.open_cart_text + '</a></span>');

                                                $zjqL('#zooomyitemadded').each(function() {
                                                    $zjqL('[id="' + this.id + '"]:gt(0)').remove();
                                                });
                                                var addtocart = "yes";
                                                $zjqL.ajax({
                                                    url: zooomListUrl+"remove-product",
                                                    data: {
                                                        shop: shop,
                                                        productid: wishlistid,
                                                        customerid: customerid,
                                                        addtocart: addtocart
                                                    },
                                                    dataType: "json",
                                                    type: "post",
                                                    async: "true",
                                                    success: function(njsonData) {
                                                        pid = njsonData.productid;
                                                        $zjqL('#ZoomyWishlistPageGrid-' + pid).remove();
                                                        $zjqL('#ZoomyWishlistPagecol-' + pid).remove();
                                                        checkEmptyWishlist();
                                                    }
                                                });
                                                myJSON = JSON.stringify(data);
                                                zooomyRefreshCartUI($zjqL);

                                                localStorage.setItem("myzooomy__wishlist", myJSON);
                                                if ($zjqL('#zooomy-wishlist-counter').length) {
                                                    document.getElementById("zooomy-wishlist-counter").innerHTML = ($zjqL('.ZoomyWishlistPageGrid').length);
                                                }
                                            } else {
                                                $zjqL(".productListIndex-"+i+ " .addcartbtn").replaceWith('<button id="' + product_id[i] + '" class="zooomybtn addcartbtn zopencartlink" value=""><a aria-label="View items in cart" href="' + cartlink + '" style="color:' + wishlist_page_add_cart_text_f_color + '">' + jsonData.open_cart_text + '</a></button>');
                                                zooomyRefreshCartUI($zjqL);
                                            }
                                        });
                                    },
                                });
                            });

                            if((jsonData.all_add_to_wishlist_status=="yes") && i==0){
                                $zjqL(`<style>#addtocartAll{text-align: center; margin:10px 1%;} .addcartbtnAll.zooomybtn{
                                        width:${jsonData.all_add_to_wishlist_width_percent!==""?jsonData.all_add_to_wishlist_width_percent:'auto'};
                                        color:#${jsonData.all_add_font_color};
                                        background-size:${jsonData.all_add_font_size};
                                        background-color:#${jsonData.all_add_background_color};
                                        border-color:#${jsonData.all_add_border_color};
                                        border:${jsonData.all_add_border_width};
                                        border-radius:${jsonData.all_add_border_radius};
                                        float:none
                                }</style>`).appendTo('body');

                                let zfloat='';
                                const zposition = jsonData.all_add_to_wishlist_position?.trim();

                                if(jsonData.all_add_to_wishlist_width_percent==""){
                                    if(zposition=="top_left" || zposition=="bottom_left"){
                                        zfloat=" zfloatleft";
                                    }else if(zposition=="top_right" || zposition=="bottom_right"){
                                        zfloat=" zfloatrigth";
                                    }  
                                }
                                
                                let addtocartAll=`<div id="addtocartAll" class="${zfloat}"><button class="addcartbtnAll zbtn zooomybtn zopencartlink">${jsonData.all_add_to_wishlist_text}</button></div>`;
                                
                                let topAddTocart=false;
                                if (zposition === "top_left" || zposition === "top_right"){
                                    topAddTocart = true;
                                }     
                                
                                if(topAddTocart){
                                    $zjqL("#ZoomyWishlistPage").before(addtocartAll); 
                                }else{
                                   $zjqL("#ZoomyWishlistPage").after(addtocartAll); 
                                }
                                
                                $zjqL("body").on("click",".addcartbtnAll",function(){
                                    let self=$zjqL(this);
                                    let formData = {
                                     'items': prIdsForAll
                                    };

                                    $zjqL.ajax({
                                        type: 'POST',
                                        url: window.Shopify.routes.root+'cart/add.js',
                                        dataType: 'json',
                                        data: formData,
                                        success: function(aItem) {
                                            let aItems = aItem.items;
                                            aItems.forEach(item=>{
                                                let productids="";
                                                let pid=item.product_id;

                                                if(localStorage.getItem("ZwishlistproIds")==undefined) {
                                                     productids=pid;
                                                }else{
                                                    let zooomywishlists=localStorage.getItem("ZwishlistproIds");
                                                    if(zooomywishlists.indexOf(pid)>-1){
                                                        productids=pid;
                                                    }else{
                                                        productids=zooomywishlists+","+pid;
                                                    }
                                                }
                                                localStorage.setItem("ZwishlistproIds",productids);
                                                if (directdelete == "true") {
                                                    var wishlistid = pid;
                                                    data = data.filter(product => {
                                                        return product.product_id != wishlistid;
                                                    });

                                                    $zjqL(".zooomyaddtowishlistmsg").append('<span id="zooomyitemadded"><a aria-label="View items in cart" href="' + cartlink + '">' + jsonData.open_cart_text + '</a></span>');

                                                    $zjqL('#zooomyitemadded').each(function() {
                                                        $zjqL('[id="' + this.id + '"]:gt(0)').remove();
                                                    });
                                                    var addtocart = "yes";
                                                    $zjqL.ajax({
                                                        url: zooomListUrl+"remove-product.php",
                                                        data: {
                                                            shop: shop,
                                                            productid: wishlistid,
                                                            customerid: customerid,
                                                            addtocart: addtocart
                                                        },
                                                        dataType: "jsonp",
                                                        jsonp: "mylinkprocode",
                                                        async: "true",
                                                        success: function(njsonData) {
                                                            pid = njsonData.productid;
                                                            $zjqL('#ZoomyWishlistPageGrid-' + pid).remove();
                                                            $zjqL('#ZoomyWishlistPagecol-' + pid).remove();
                                                            checkEmptyWishlist();
                                                        }
                                                    });
                                                    myJSON = JSON.stringify(data);
                                                    localStorage.setItem("myzooomy__wishlist", myJSON);
                                                    if ($zjqL('#zooomy-wishlist-counter').length) {
                                                        var wishcountval = ($zjqL('.ZoomyWishlistPageGrid').length);
                                                        document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>"+wishcountval+"</span>";  
                                                    }
                                                } else {
                                                    $zjqL("button#" + pid).replaceWith('<button id="' + pid + '" class="zooomybtn addcartbtn zopencartlink" value=""><a aria-label="View items in cart" href="' + cartlink + '" style="color:' + wishlist_page_add_cart_text_f_color + '">' + jsonData.open_cart_text + '</a></button>');
                                                    self.text(jsonData.open_cart_text);
                                                }
                                            });
                                            zooomyRefreshCartUI($zjqL);
                                        }   
                                    });
                                });
                            }
                        },
                        error: function(cartvalues) {
                            var $card =$zjqL(".productListIndex-" + i);
                            $card.addClass("z_w_unavailable");
                            $card.find(".zbodyaction").html("<button class='zbtn zooomybtn addcartbtn zopencartlink z_w_soldout zunavailable' disabled>Currently unavailable</button>");
                            $card.find(".zbodypimg a, .zbodytitle a").removeAttr("href").css("pointer-events", "none");
                        },
                    });
                });

                $zjqL(document).on('click', '.removefromwishlist', function() {
                    var wishlistid = $zjqL(this).val();
                    data = data.filter(product => {
                        return product.product_id != wishlistid;
                    });

                    $zjqL.ajax({
                        url: zooomListUrl+"remove-product",
                        data: {
                            shop: shop,
                            productid: wishlistid,
                            customerid: customerid
                        },
                        dataType: "json",
                        type: "post",
                        async: "true",
                        success: function(njsonData) {
                            pid = njsonData.productid;
                            $zjqL('#ZoomyWishlistPageGrid-' + pid).remove();
                            $zjqL('#ZoomyWishlistPagecol-' + pid).remove();
                            checkEmptyWishlist();
                        }
                    });
                    myJSON = JSON.stringify(data);

                    localStorage.setItem("myzooomy__wishlist", myJSON);
                    if ($zjqL('#zooomy-wishlist-counter').length) {
                        document.getElementById("zooomy-wishlist-counter").innerHTML = ($zjqL('.ZoomyWishlistPageGrid').length);
                    }
                });

                // Toggle Email Form
                $zjqL("#emailzwishlist").click(function() {
                    var $eData =$zjqL("#zemaildata");
                    var isVisible = $eData.is(":visible");
                    $eData.slideToggle('100', function() {
                        var nowVisible = $eData.is(":visible");
                        $eData.attr("aria-hidden", (!nowVisible).toString());
                        $zjqL("#emailzwishlist").attr("aria-expanded", nowVisible.toString());
                    });
                });

                $zjqL("#zsendemail").click(function() {
                    var zemailid = $zjqL("#zemailid").val();
                    var zemailname = $zjqL("#zemailname").val();
                    var zemailmsg = $zjqL("#zemailmsg").val();
                    if (zemailname == "") {
                        $zjqL("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwsubject'>Add Subject.</span>");
                    }
                    if (zemailid == "") {
                        $zjqL("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwemail'>Add Email address.</span>");
                    }
                    if (zemailid != "" && zemailname != "") {
                        var getcusid = customerid;

                        $zjqL.ajax({
                            url: "https://zooomyapps.com/wishlist/email-list?shop=" + shop + "&getcusid=" + getcusid + "&zemailid=" + zemailid,
                            data: {
                                shop: shop,
                                getcusid: getcusid,
                                zemailid: zemailid,
                                zemailname: zemailname,
                                zemailmsg: zemailmsg
                            },
                            dataType: "json",
                            async: "true",
                            success: function(ejsonData) {
                                var emailed = ejsonData.emailed;
                                if (emailed == "sent") {}
                            }
                        });
                        $zjqL("#zemaildata").slideToggle('100', function() {
                            $zjqL("#zemaildata").attr("aria-hidden", "true");
                            $zjqL("#emailzwishlist").attr("aria-expanded", "false");
                        });
                        $zjqL("#emailzwishlist").before("<span class='emailsentz'>Email has been sent</span>");
                    }
                });

                $zjqL(".zooomylink_fa").click(function() {
                    $zjqL("#zooomycopytxtarea").attr("aria-hidden", "false").fadeIn(1000);
                    setTimeout(function() {
                        $zjqL("#zooomycopytxtarea").fadeOut(400, function() {
                            $zjqL("#zooomycopytxtarea").attr("aria-hidden", "true");
                        });
                    }, 15000);
                });

                function zooomywishlistpage(zpagepid, customeremail, customerid) {
                    if (localStorage.getItem("ZwishlistPageEmail") == undefined || localStorage.getItem("ZwishlistPageEmail") == "") {
                        var customeremail = customeremail;
                    } else {
                        var zooomywishlists = localStorage.getItem("ZwishlistPageEmail");
                    }
                    localStorage.setItem("ZwishlistPageEmail", customeremail);

                    if (localStorage.getItem("ZwishlistPageid") == undefined || localStorage.getItem("ZwishlistPageid") == "") {
                        var customerid = customerid;
                    } else {
                        var zooomywishlists = localStorage.getItem("ZwishlistPageId");
                    }
                    localStorage.setItem("ZwishlistPageId", customerid);

                    if (localStorage.getItem("ZwishlistpageproIds") == undefined) {
                        var productids = zpagepid;
                    } else {
                        var zooomywishlistpages = localStorage.getItem("ZwishlistpageproIds");
                        if (zooomywishlistpages.indexOf(zpagepid) > -1) {
                            var productids = zpagepid;
                        } else {
                            var productids = zooomywishlistpages + "," + zpagepid;
                        }
                    }
                    localStorage.setItem("ZwishlistpageproIds", productids);
                    return true;
                }
                
                $zjqL('<style>.zooomywishlistgridclass img { width: 100%; }a#emailzwishlist { display: none; }.zooomywishlistgridclass .ZoomyWishlistPageGrid span.zooomybtn, .zopencartlink {border-radius:0px; margin: 10px auto; float: left;width: 100%;}.ZoomyWishlistPageGrid span.zooomybtn { margin: 2px 0 0!important; }.ZoomyWishlistPageGrid span.zooomybtn { margin: 2px 0 0!important; text-align: center; cursor: pointer; font-family: inherit; font-weight: normal; font-style: normal; font-size: 15px; padding: 10px; text-transform: uppercase; letter-spacing: 3px;} .Product__QuickNav{clear: both;}.z_social_share_wishlist { float: none; width: 175px; margin: 0 auto; }a#emailzwishlist { display: none; }.zooomy__hhrt{display:none;}.zooomybtn.removefromwishlist.zremovefromwish{min-width:0;}.z_social_share_wishlist a, #ZoomyWishlistPage a { font-size: 15px; }.zbodyaction .zopencartlink { padding: 10px 10px; font-family: inherit; font-size: 15px; font-weight: normal; height: auto; }.ZoomyWishlistPageGrid span.zooomybtn, .zopencartlink { padding: 9px 20px; font-family: inherit; letter-spacing: 0; text-transform: inherit;}.zooomyshopvariant{width:100%;}#ZoomyWishlistPage a.zmsg { color: #000; margin-bottom: 40px; }.template-page .rte.reading-width { max-width: 100%; }.zooomywishlistgridclass .ZoomyWishlistPageGrid .zbodyaction span.zooomybtn { padding: 10px 10px; width: 100%; float: left; }div#shopify-section-framework--footer { clear: both; }.zooomywishlistlistclass .zbodyaction .zopencartlink { width: auto; }</style>').appendTo('body');
                $zjqL('<style>' + user_added_css + '</style>').appendTo('body');
                
                numItems = $zjqL('.ZoomyWishlistPageGrid').length;
                if ($zjqL('.zooomyIconval').length) {
                    if (numItems > 0) {
                        $zjqL('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                    }
                }

                if ($zjqL('#zooomy-wishlist-counter').length) {
                    document.getElementById("zooomy-wishlist-counter").innerHTML = numItems;
                }
            }
        });
    }

    var callAllfunctionW = function (jQuery) {
        let shop = zooomyWish.shop ?? Shopify.shop;
        let customerid = zooomyWish.customerId ?? (meta.page.customerId ?? "");
        let totalv = 0; 
        let customeremail = zooomyWish.customerEmail ?? "";
        var checkPage = document.querySelectorAll("#ZoomyWishlistPage");
        if (!jQuery("#zooomy-a11y-style").length) {
            jQuery("head").append(`
                <style id="zooomy-a11y-style">
                    .zooomy-sr-only {
                        position: absolute !important;
                        width: 1px !important;
                        height: 1px !important;
                        padding: 0 !important;
                        margin: -1px !important;
                        overflow: hidden !important;
                        clip: rect(0, 0, 0, 0) !important;
                        white-space: nowrap !important;
                        border: 0 !important;
                    }
                </style>
            `);
        }
        if(checkPage.length > 0){
            ZooomyDataFun(jQuery, shop, customerid, customeremail);
        }
    }

    function unescapeHtml(str) {
       return str
        .replace(/&/g, "&amp;")
        .replace(/'/g, "&#39;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    function getCurrencySymbol(currencyCode, locale = undefined) {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay:'narrowSymbol',  
        minimumFractionDigits: 0
      })
        .formatToParts(1)
        .find(part => part.type === 'currency').value;
    }

    function zooomyRefreshCartUI($zjqL, openDrawer) {
        openDrawer = openDrawer !== false;
        var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";

        function unlockPageScroll() {
            try {
                document.documentElement.classList.remove("js-drawer-open", "cart-drawer-open", "overflow-hidden", "no-scroll");
                document.body.classList.remove("js-drawer-open", "cart-drawer-open", "overflow-hidden", "no-scroll");
                document.documentElement.style.removeProperty("overflow");
                document.body.style.removeProperty("overflow");
                document.documentElement.removeAttribute("inert");
            } catch (error) {
                console.warn("Zooomy: unable to unlock page scroll.", error);
            }
        }

        function triggerCartEvents(cart) {
            var events = ["cart:updated", "cart:refresh"];
            events.forEach(function(eventName) {
                try {
                    document.dispatchEvent(new CustomEvent(eventName, { detail: { cart: cart, source: "zooomy-wishlist" } }));
                } catch (error) {}
            });
        }

        function updateCartCount(cart) {
            if (!cart) return;
            var count = parseInt(cart.item_count, 10) || 0;
            var selectors = [
                "cart-count", "[data-cart-count]", ".cart-count", ".cart-count-bubble span",
                "#CartCount", ".cart-link__count", ".thb-item-count", ".header__cart-count-number",
                ".header__cart__status", ".cart__items-count", ".site-header__cart-count",
                ".js-cart-count", "[data-header-cart-count]"
            ].join(",");

            $zjqL(selectors).each(function() {
                var $element =$zjqL(this);
                $element.text(count);$element.attr("data-cart-count", count);
                if (count > 0) {
                    $element.removeClass("is-empty hidden");
                } else {
                    $element.addClass("is-empty");
                }
            });

            $zjqL(".cart-link__bubble, .thb-item-count, .cart-count-bubble").each(function() {
                var $element =$zjqL(this);
                if (count > 0) {
                    $element.addClass("cart-link__bubble--visible").removeClass("hidden");
                } else {
                    $element.removeClass("cart-link__bubble--visible");
                }
            });
        }

        function getCartSections() {
            var sections = ["cart-drawer", "cart-icon-bubble", "cart-notification", "cart-notification-product"];
            var sectionElements = document.querySelectorAll("[data-section-type='cart-drawer'], [data-section-id*='cart_drawer'], [data-section-id*='cart-drawer'], [id*='cart_drawer'], [id*='cart-drawer'], #shopify-section-cart-drawer");
            sectionElements.forEach(function(element) {
                var sectionId = element.getAttribute("data-section-id") || "";
                if (sectionId && sections.indexOf(sectionId) === -1) {
                    sections.push(sectionId);
                }
                if (element.id && element.id.indexOf("shopify-section-") === 0) {
                    var idSection = element.id.replace("shopify-section-", "");
                    if (idSection && sections.indexOf(idSection) === -1) {
                        sections.push(idSection);
                    }
                }
            });
            return sections;
        }

        function fetchCartSections() {
            var sections = getCartSections();
            return fetch(rootUrl + "?sections=" + encodeURIComponent(sections.join(",")), {
                credentials: "same-origin",
                headers: { "X-Requested-With": "XMLHttpRequest" }
            }).then(function(response) {
                if (!response.ok) throw new Error("Could not refresh cart sections.");
                return response.json();
            });
        }

        function tryNativeSectionRender(sectionsHtml) {
            if (!sectionsHtml) return false;
            var renderData = { sections: sectionsHtml, id: null };

            var shoppingCart = document.querySelector("shopping-cart");
            if (shoppingCart && typeof shoppingCart.renderContents === "function") {
                try { shoppingCart.renderContents(renderData); return true; } catch (error) {}
            }
            var cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer && typeof cartDrawer.renderContents === "function") {
                try { cartDrawer.renderContents(renderData); return true; } catch (error) {}
            }
            var cartNotification = document.querySelector("cart-notification");
            if (cartNotification && typeof cartNotification.renderContents === "function") {
                try { cartNotification.renderContents(renderData); return true; } catch (error) {}
            }
            return false;
        }

        function replaceSectionHtml(sectionsHtml) {
            if (!sectionsHtml) return;
            Object.keys(sectionsHtml).forEach(function(sectionName) {
                var html = sectionsHtml[sectionName];
                if (!html) return;
                var temporaryContainer = document.createElement("div");
                temporaryContainer.innerHTML = html;

                var currentShoppingCart = document.querySelector("shopping-cart");
                var newShoppingCart = temporaryContainer.querySelector("shopping-cart");
                if (currentShoppingCart && newShoppingCart) {
                    currentShoppingCart.innerHTML = newShoppingCart.innerHTML;
                }

                var currentCartDrawer = document.querySelector("cart-drawer");
                var newCartDrawer = temporaryContainer.querySelector("cart-drawer");
                if (currentCartDrawer && newCartDrawer) {
                    currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                    currentCartDrawer.className = newCartDrawer.className;
                }

                var currentNotification = document.querySelector("cart-notification");
                var newNotification = temporaryContainer.querySelector("cart-notification");
                if (currentNotification && newNotification) {
                    currentNotification.innerHTML = newNotification.innerHTML;
                    currentNotification.className = newNotification.className;
                }

                var currentGenericDrawer = document.querySelector("#CartDrawer, #cart-drawer, .drawer--cart, [data-cart-drawer]");
                var newGenericDrawer = temporaryContainer.querySelector("#CartDrawer, #cart-drawer, .drawer--cart, [data-cart-drawer]");
                if (currentGenericDrawer && newGenericDrawer && currentGenericDrawer !== currentCartDrawer) {
                    currentGenericDrawer.innerHTML = newGenericDrawer.innerHTML;
                    currentGenericDrawer.className = newGenericDrawer.className;
                }

                if (sectionName.indexOf("cart-icon") !== -1 || temporaryContainer.querySelector("[data-cart-count], cart-count, .cart-count-bubble")) {
                    var newCountElement = temporaryContainer.querySelector("cart-count, [data-cart-count], .cart-count-bubble, #CartCount");
                    var currentCountElements = document.querySelectorAll("cart-count, [data-cart-count], .cart-count-bubble, #CartCount");
                    if (newCountElement && currentCountElements.length) {
                        currentCountElements.forEach(function(currentCountElement) {
                            currentCountElement.innerHTML = newCountElement.innerHTML;
                        });
                    }
                }
            });
        }

        function openCartDrawerUI() {
            if (!openDrawer) return;
            unlockPageScroll();

            var shoppingCart = document.querySelector("shopping-cart");
            if (shoppingCart) {
                if (typeof shoppingCart.showCart === "function") {
                    try { shoppingCart.showCart(); return; } catch (error) {}
                }
                var cartCheckbox = document.querySelector("input#cart[type='checkbox']");
                if (cartCheckbox) {
                    try {
                        cartCheckbox.checked = true;
                        cartCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
                        return;
                    } catch (error) {}
                }
            }

            var cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer && typeof cartDrawer.open === "function") {
                try { cartDrawer.open(); return; } catch (error) {}
            }

            var cartNotification = document.querySelector("cart-notification");
            if (cartNotification && typeof cartNotification.open === "function") {
                try { cartNotification.open(); return; } catch (error) {}
            }

            var genericDrawer = document.querySelector("#cart-drawer, #CartDrawer, .drawer--cart, [data-cart-drawer]");
            if (genericDrawer) {
                genericDrawer.classList.add("is-open", "is-active", "active", "drawer--open", "animate");
                genericDrawer.classList.remove("is-empty", "is-closed", "hidden");
                genericDrawer.setAttribute("aria-hidden", "false");
                genericDrawer.setAttribute("open", "");
                genericDrawer.removeAttribute("inert");
            }

            var underlay = document.querySelector(".drawer__underlay, [data-drawer-underlay]");
            if (underlay) {
                underlay.classList.add("is-visible", "is-open");
            }

            var safeCartToggle = document.querySelector("button[data-cart-toggle], button[data-cart-drawer-toggle], button.js-drawer-open-cart, button[aria-controls='CartDrawer'], button[aria-controls='cart-drawer'], label[for='cart']");
            if (safeCartToggle) {
                try { safeCartToggle.click(); } catch (error) {}
            }

            try {
                document.dispatchEvent(new CustomEvent("theme:drawer:open", { detail: { drawer: "cart", source: "zooomy-wishlist" } }));
                document.dispatchEvent(new CustomEvent("cart:drawer:open", { detail: { source: "zooomy-wishlist" } }));
            } catch (error) {}
        }

        function refreshUsingSections(cart) {
            return fetchCartSections().then(function(sectionsHtml) {
                var nativeRenderUsed = tryNativeSectionRender(sectionsHtml);
                if (!nativeRenderUsed) {
                    replaceSectionHtml(sectionsHtml);
                }
                if (cart) {
                    updateCartCount(cart);
                }
                if (openDrawer) {
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            openCartDrawerUI();
                            resolve(cart);
                        }, nativeRenderUsed ? 150 : 50);
                    });
                }
                return cart;
            });
        }

        return fetch(rootUrl + "cart.js", {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(function(response) {
            if (!response.ok) throw new Error("Could not retrieve the cart.");
            return response.json();
        })
        .then(function(cart) {
            updateCartCount(cart);
            triggerCartEvents(cart);

            var shoppingCart = document.querySelector("shopping-cart");
            if (openDrawer && shoppingCart && typeof shoppingCart.updateCart === "function") {
                try {
                    var result = shoppingCart.updateCart();
                    if (result && typeof result.then === "function") {
                        return result.then(function() { return cart; });
                    }
                    return cart;
                } catch (error) {}
            }
            return refreshUsingSections(cart);
        })
        .catch(function(error) {
            return refreshUsingSections(null).catch(function(sectionError) {
                openCartDrawerUI();
                return null;
            });
        });
    }

    function reqJqueryL() {
        if ("undefined" == typeof jQuery || !jQuery || 1 === parseInt(jQuery.fn.jquery) && 11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, ""))) {
            var o = document.getElementsByTagName("head")[0],
                t = document.createElement("script");
            t.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js", t.type = "text/javascript", t.onload = t.onreadystatechange = function() {
                t.readyState ? "complete" !== t.readyState && "loaded" !== t.readyState || (t.onreadystatechange = null, callAllfunctionW(jQuery.noConflict(!0))) : callAllfunctionW(jQuery.noConflict(!0))
            }, o.appendChild(t);
        } else { callAllfunctionW(jQuery); }
    }

    reqJqueryL();
})();